// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LZTK","rootMobile":"styles_rootMobile__3fgYO"};